import { useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "../supabase";
import Seo from "../components/Seo";
import "../components/booth/tokens.css";
import BoothMark from "../components/booth/BoothMark";
import Footer from "../components/booth/Footer";
import "./VerifyEmail.css";

const MISSING_TOKEN_MESSAGE =
  "This verification link is missing or malformed. Please request a new one.";

function VerifyEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tokenHash = searchParams.get("token_hash");
  const type = searchParams.get("type") || "signup";

  const [status, setStatus] = useState(tokenHash ? "ready" : "error"); // "ready", "verifying", "success", "error"
  const [errorMessage, setErrorMessage] = useState(tokenHash ? "" : MISSING_TOKEN_MESSAGE);
  const verifyingRef = useRef(false);

  const handleVerify = async () => {
    if (verifyingRef.current) return;
    verifyingRef.current = true;
    setStatus("verifying");

    try {
      const { data, error } = await supabase.auth.verifyOtp({
        token_hash: tokenHash,
        type,
      });

      if (error || !data?.session) {
        setStatus("error");
        setErrorMessage(
          error?.message || "We couldn't verify this link. Please request a new one."
        );
        verifyingRef.current = false;
        return;
      }

      setStatus("success");
      setTimeout(() => navigate("/dashboard"), 1200);
    } catch (error) {
      setStatus("error");
      setErrorMessage("Verification failed. Please try again.");
      verifyingRef.current = false;
    }
  };

  const renderContent = () => {
    switch (status) {
      case "ready":
        return (
          <>
            <h1 className="booth-auth-title">Confirm your email.</h1>
            <p className="booth-verify-dek">
              Click below to finish verifying your account.
            </p>
            <button
              type="button"
              className="booth-btn booth-btn--primary booth-auth-submit"
              onClick={handleVerify}
            >
              Verify email <span aria-hidden="true">→</span>
            </button>
          </>
        );

      case "verifying":
        return (
          <>
            <h1 className="booth-auth-title">Verifying your email.</h1>
            <p className="booth-verify-dek">
              Please wait while we verify your email address.
            </p>
          </>
        );

      case "success":
        return (
          <>
            <h1 className="booth-auth-title">Email verified.</h1>
            <p className="booth-verify-dek">
              Taking you to your dashboard…
            </p>
          </>
        );

      case "error":
        return (
          <>
            <h1 className="booth-auth-title">We couldn't verify your email.</h1>
            <p className="booth-verify-dek">{errorMessage}</p>
            <button
              type="button"
              className="booth-btn booth-btn--primary booth-auth-submit"
              onClick={() => navigate("/auth")}
            >
              Back to log in <span aria-hidden="true">→</span>
            </button>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="booth booth-verify-page">
      <Seo
        title="Verify your email — The Booth"
        description="Confirming your Booth account email address."
        path="/verifyEmail"
        noindex
      />
      <header className="booth-shell booth-verify-masthead">
        <a
          href="/"
          className="booth-verify-mark-link"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <BoothMark />
        </a>
      </header>
      <main className="booth-shell booth-verify-main">
        <div className="booth-auth-card">{renderContent()}</div>
      </main>
      <Footer />
    </div>
  );
}

export default VerifyEmail;
